import { render, staticRenderFns } from "./selectTiandituPos.vue?vue&type=template&id=9f18ab5e&scoped=true"
import script from "./selectTiandituPos.vue?vue&type=script&lang=js"
export * from "./selectTiandituPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f18ab5e",
  null
  
)

export default component.exports